import { type SeTenants, type ReviewState, PhilatelicItemType, WithoutIdAndReview } from "@briefmarken_katalog/types";
import type { TranslationKey } from "$lib/i18n";
import { CollectionEditorModelBase } from "./CollectionEditorModelBase.svelte";

export class SeTenantsEditorModel extends CollectionEditorModelBase<SeTenants> {
  constructor({
    onCreate = (_seTenants: WithoutIdAndReview<SeTenants>) => {},
    onReview = (_seTenants: WithoutIdAndReview<SeTenants>, _state: ReviewState) => {},
    onDelete = () => {},
    isReadonly = false,
    isReview = false,
    isDelete = false,
    isEdit = false,
    initialValue = null,
    dialogTitle = 'editor.seTenantsEditorTitle' as TranslationKey,
    dialogSubtitle = 'editor.seTenantsEditorSubtitle' as TranslationKey,
  }: {
    onCreate?: (seTenants: WithoutIdAndReview<SeTenants>) => void;
    onReview?: (seTenants: WithoutIdAndReview<SeTenants>, state: ReviewState) => void;
    onDelete?: () => void;
    isReadonly?: boolean;
    isReview?: boolean;
    isDelete?: boolean;
    isEdit?: boolean;
    initialValue?: SeTenants | null;
    dialogTitle?: TranslationKey;
    dialogSubtitle?: TranslationKey;
  } = {}) {
    super({ onCreate, onReview, onDelete, isReadonly, isReview, isDelete, isEdit,
            initialValue, dialogTitle, dialogSubtitle });
  }

  override handleImageUpload(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (e: ProgressEvent<FileReader>) => {
      this.pictures = [{ base64: e.target?.result as string }];
      this.picturesDirty = true;
    };
    reader.readAsDataURL(file);
  }

  override setPictureFromPhone(picture: import('@briefmarken_katalog/types').ImageType): void {
    this.pictures = [picture];
    this.picturesDirty = true;
  }

  buildItem(): WithoutIdAndReview<SeTenants> {
    return {
      title: this.title,
      description: this.description,
      date_of_issue: this.date_of_issue!,
      expiry_date: this.expiry_date ?? undefined,
      print_run: this.print_run ?? undefined,
      categories: this.categories.length > 0 ? this.categories : undefined,
      catalog_ids: Object.keys(this.catalog_ids).length > 0 ? this.catalog_ids : undefined,
      zhihao: this.zhihao,
      pictures: this.pictures,
      stamps: this.stampIds,
      type: PhilatelicItemType.SeTenants,
    };
  }
}
